import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Dialog } from "./components/index.js";
import { Modal } from "react-responsive-modal";
import './ConfirmNoCoverageModal.scss';
import { useEffect } from 'react';

export default function ConfirmNoCoverageModal(props){
  const {t} = useTranslation();

  
  const [isOpen, setIsOpen] = useState(props.isOpen);

  useEffect(() => {
    setIsOpen(!!props.isOpen);
  }, [props.isOpen]);

  const onNoClicked = () => {
    setIsOpen(false);
    if(typeof props.onNo === 'function'){
      props.onNo();
    }
  }

  const onYesClicked = () => {
    setIsOpen(false);
    if(typeof props.onYes === 'function'){
      props.onYes();
    }
  }

  const onClose = () => {
    setIsOpen(false);
  };

  return (
  <>
    <Modal classNames={{modal: 'TVLAccidentModal'}} open={isOpen} onClose={onClose} closeOnOverlayClick={false} closeOnEsc={false} showCloseIcon={false}>
      {/* <h2 style={{marginTop: 30}}>{t("description.TVLAccidentQuestionHeader")}</h2> */}
      <img className="img" src={props.logo} alt="trx now logo" />
      <div class="message">Since this vehicle is not listed on your contract we're unable to confirm if your coverage applies.  We can still provide you with Roadside Assistance, but we'll need to collect your credit card information to process payment, which you can then submit to Louisiana Dealer Services Claim department for reimbursement review.</div>
      <div className="footerContainer">
        <div type="hidden" onClick={onYesClicked} className="footer">
          <span>{t("description.ConfirmServicesFlatYes")}</span>
        </div>
        <div type="hidden" onClick={onNoClicked} className="footer">
          <span>{t("description.ConfirmServicesFlatNo")}</span>
        </div>
      </div>
    </Modal>
  </>);

}